var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 12,
    height: 12,
    transform: "translate(39 143)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_627",
    "data-name": "Mask Group 627",
    transform: "translate(-39 -143)",
    clipPath: "url(#trash)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_70_",
    "data-name": "svgexport-6 (70)",
    transform: "translate(40.112 143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11477",
    "data-name": "Path 11477",
    d: "M8.611,5.8a.277.277,0,0,0-.277.277v5.242a.277.277,0,1,0,.555,0V6.074A.277.277,0,0,0,8.611,5.8Zm0,0",
    transform: "translate(-2.165 -1.506)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11478",
    "data-name": "Path 11478",
    d: "M4.189,5.8a.277.277,0,0,0-.277.277v5.242a.277.277,0,1,0,.555,0V6.074A.277.277,0,0,0,4.189,5.8Zm0,0",
    transform: "translate(-1.016 -1.506)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11479",
    "data-name": "Path 11479",
    d: "M.788,3.526V10.36a1.53,1.53,0,0,0,.407,1.055,1.366,1.366,0,0,0,.991.429H7.433a1.366,1.366,0,0,0,.991-.429,1.53,1.53,0,0,0,.407-1.055V3.526A1.06,1.06,0,0,0,8.56,1.442H7.139V1.1A1.09,1.09,0,0,0,6.041,0H3.578a1.09,1.09,0,0,0-1.1,1.1v.347H1.059A1.06,1.06,0,0,0,.788,3.526Zm6.646,7.763H2.186a.878.878,0,0,1-.843-.929V3.55H8.277V10.36a.878.878,0,0,1-.843.929ZM3.034,1.1A.534.534,0,0,1,3.578.555H6.041a.534.534,0,0,1,.544.541v.347H3.034ZM1.059,2h7.5a.5.5,0,1,1,0,1h-7.5a.5.5,0,1,1,0-1Zm0,0",
    transform: "translate(0 0)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11480",
    "data-name": "Path 11480",
    d: "M6.4,5.8a.277.277,0,0,0-.277.277v5.242a.277.277,0,1,0,.555,0V6.074A.277.277,0,0,0,6.4,5.8Zm0,0",
    transform: "translate(-1.59 -1.506)",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.fd364a828c4427d1d570e22db808ae87.svg";
export { ForwardRef as ReactComponent };